// @ts-check
import ProfileImage from './ProfileImage';

export default ProfileImage;
